import createIcon from '../../createIcon';

/**
 * @component @name SupportAgent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTIuMjJDMjEgNi43MyAxNi43NCAzIDEyIDNDNy4zMSAzIDMgNi42NSAzIDEyLjI4QzIuNCAxMi42MiAyIDEzLjI2IDIgMTRWMTZDMiAxNy4xIDIuOSAxOCA0IDE4SDVWMTEuOUM1IDguMDMgOC4xMyA0LjkgMTIgNC45QzE1Ljg3IDQuOSAxOSA4LjAzIDE5IDExLjlWMTlIMTFWMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjE3Ljc4QzIxLjU5IDE3LjQ3IDIyIDE2Ljg2IDIyIDE2LjE0VjEzLjg0QzIyIDEzLjE0IDIxLjU5IDEyLjUzIDIxIDEyLjIyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkgMTRDOS41NTIyOCAxNCAxMCAxMy41NTIzIDEwIDEzQzEwIDEyLjQ0NzcgOS41NTIyOCAxMiA5IDEyQzguNDQ3NzIgMTIgOCAxMi40NDc3IDggMTNDOCAxMy41NTIzIDguNDQ3NzIgMTQgOSAxNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNSAxNEMxNS41NTIzIDE0IDE2IDEzLjU1MjMgMTYgMTNDMTYgMTIuNDQ3NyAxNS41NTIzIDEyIDE1IDEyQzE0LjQ0NzcgMTIgMTQgMTIuNDQ3NyAxNCAxM0MxNCAxMy41NTIzIDE0LjQ0NzcgMTQgMTUgMTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTggMTEuMDNDMTcuNTIgOC4xOCAxNS4wNCA2IDEyLjA1IDZDOS4wMiA2IDUuNzYgOC41MSA2LjAyIDEyLjQ1QzguNDkgMTEuNDQgMTAuMzUgOS4yNCAxMC44OCA2LjU2QzEyLjE5IDkuMTkgMTQuODggMTEgMTggMTEuMDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SupportAgent = createIcon('SupportAgent', [
  [
    'path',
    {
      d: 'M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18H5V11.9C5 8.03 8.13 4.9 12 4.9C15.87 4.9 19 8.03 19 11.9V19H11V21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z',
      key: 'y2gkwn',
    },
  ],
  [
    'path',
    {
      d: 'M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z',
      key: '1bj5xq',
    },
  ],
  [
    'path',
    {
      d: 'M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z',
      key: 'q6tbme',
    },
  ],
  [
    'path',
    {
      d: 'M18 11.03C17.52 8.18 15.04 6 12.05 6C9.02 6 5.76 8.51 6.02 12.45C8.49 11.44 10.35 9.24 10.88 6.56C12.19 9.19 14.88 11 18 11.03Z',
      key: '1j8b11',
    },
  ],
]);

export default SupportAgent;
